import {
	GET_CHARTS,
	GET_CHARTS_SUCCESS,
	GET_CHARTS_FAILURE,
	INVITE_MEMBERS,
	EXPORT_CHART,
	SHARE_CHART,
} from './types';

export const getChartsAction = () => ({
	type: GET_CHARTS,
});

export const getChartsSuccessAction = (payload: any) => ({
	type: GET_CHARTS_SUCCESS,
	payload,
});

export const getChartsFailureAction = (error: Error) => ({
	type: GET_CHARTS_FAILURE,
	payload: error,
});

export const inviteMembersAction = (payload: any) => ({
	type: INVITE_MEMBERS,
	payload,
});

export const shareChartAction = (payload: any) => ({
	type: SHARE_CHART,
	payload,
});

export const exportChartAction = (payload: any) => ({
	type: EXPORT_CHART,
	payload,
});
